/** Align with backend constants/permissions.js and mst_submodules.submodule_slug */
export const SCHEDULE_ENTRY_SUBMODULE_SLUG = "schedule-entry";
export const SCHEDULE_CONTROL_SUBMODULE_SLUG = "schedule-control";
